import React, { type InputHTMLAttributes, useRef } from 'react';

import CheckIcon from '@pkg/assets/icons/v2/check-input.svg?react';

import { Input, InputContent, InputIcon, InputLabel, InputWrapper } from './ValidationInput.style.ts';

interface YatValidationInputProps extends InputHTMLAttributes<HTMLInputElement> {
    classes?: string[];
    isValid?: boolean;
    label?: string;
}

const YatValidationInput = ({ classes, isValid, label, ...props }: YatValidationInputProps) => {
    const urlInputRef = useRef() as React.MutableRefObject<HTMLInputElement>;
    function setFocusOnInput(e) {
        if (urlInputRef && urlInputRef.current) {
            urlInputRef.current.focus();
            e.preventDefault();
        }
    }
    return (
        <InputWrapper onClick={setFocusOnInput}>
            <InputContent>
                <InputLabel>{label}</InputLabel>
                <Input ref={urlInputRef} {...props} />
            </InputContent>
            {isValid ? (
                <InputIcon>
                    <CheckIcon />
                </InputIcon>
            ) : null}
        </InputWrapper>
    );
};

export default YatValidationInput;
